import { useWatch } from 'react-hook-form';
import { FormValues, fieldNames } from './schema';

export const useFormAbsoluteLimitValue = () => useWatch<FormValues>({ name: fieldNames.absolutePerTimeUnitLimit });
